import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { sendPasswordReset } from 'src/redux/actions/auth.action';
import { logoutSuccess } from 'src/redux/reducers/auth.slice';
import { IconMail, IconSend } from '../components/AuthIcons';

const schema = yup.object().shape({
  email: yup.string().email('Enter a valid email').required('Email is required'),
});

function ForgotPasswordForm() {
  const dispatch = useDispatch();
  const { isLoading, error } = useSelector((state) => state.login);
  const [emailSent, setEmailSent] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: { email: '' },
  });

  const onSubmit = async (model) => {
    const result = await dispatch(sendPasswordReset(model.email));
    if (result?.success) {
      setEmailSent(true);
    }
  };

  return (
    <>
      {error && !emailSent && (
        <div className="auth-alert auth-alert-error" role="alert">
          {error}
          <button
            type="button"
            onClick={() => dispatch(logoutSuccess())}
            style={{ float: 'right', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 700 }}
            aria-label="Dismiss error"
          >
            ×
          </button>
        </div>
      )}

      {emailSent && (
        <div className="auth-alert auth-alert-success" role="status">
          Check your inbox for a secure reset link. It expires in 30 minutes.
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="field">
          <label htmlFor="email">Email</label>
          <div className="ctrl">
            <span className="lead">
              <IconMail />
            </span>
            <input
              id="email"
              type="email"
              placeholder="you@company.com"
              className={`inp has-lead ${errors.email ? 'inp-error' : ''}`}
              {...register('email')}
            />
          </div>
          {errors.email && <span className="field-error">{errors.email.message}</span>}
        </div>

        <button className="btn-primary" type="submit" disabled={isLoading || emailSent}>
          <IconSend />
          {isLoading ? 'Sending…' : 'Send reset email'}
        </button>
      </form>

      <div className="divider">or</div>
      <div className="alt" style={{ paddingTop: 14 }}>
        Remembered it?{' '}
        <Link className="link" to="/login">
          Back to log in
        </Link>
        &nbsp;·&nbsp;
        <Link className="link" to="/register">
          Create account
        </Link>
      </div>
    </>
  );
}

export default ForgotPasswordForm;
